import { render, staticRenderFns } from "./email_details.vue?vue&type=template&id=07b77f18&scoped=true&"
import script from "./email_details.vue?vue&type=script&lang=js&"
export * from "./email_details.vue?vue&type=script&lang=js&"
import style0 from "./email_details.vue?vue&type=style&index=0&id=07b77f18&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b77f18",
  null
  
)

export default component.exports